import React from 'react';
import './styles.css';

const Body = (props) => {
  const { children } = props;
  return <div className="container">{children}</div>;
};

export default Body;
